import { Link } from '@remix-run/react'
import { useState } from 'react'
import { type RaceEntry } from '#app/utils/contentful.types'
import { cn } from '#app/utils/misc.tsx'

export default function RaceCard({ race }: { race: RaceEntry }) {
	const [isExpanded, setIsExpanded] = useState(false)

	const toggleExpansion = (e: React.MouseEvent) => {
		e.preventDefault()
		e.stopPropagation()
		setIsExpanded(!isExpanded)
	}

	const getRacePictureUrl = () => {
		const pictures = race.racePicturesCollection?.items
		return pictures && pictures.length > 0 ? pictures[0]?.url : ''
	}

	const raceSlug = race.raceName.toLowerCase().replace(/\s+/g, '-')

	return (
		<Link
			to={`/running/${raceSlug}`}
			reloadDocument
			className={cn(
				'relative mx-auto flex w-full max-w-xs cursor-pointer flex-col rounded-lg bg-white shadow-lg transition-all duration-300',
				isExpanded ? 'z-10' : '',
			)}
		>
			<div className="relative h-48">
				{getRacePictureUrl() && (
					<img
						src={getRacePictureUrl() ?? ''}
						alt={race.raceName}
						className="h-full w-full object-cover"
					/>
				)}
				<div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 p-2">
					<h3 className="text-center text-2xl font-bold text-white">
						{race.raceName}
					</h3>
				</div>
			</div>
			<div className="flex-grow p-4">
				<div className={cn(isExpanded ? '' : 'h-[100px] overflow-hidden')}>
					<p className={isExpanded ? '' : 'line-clamp-3'}>{race.raceNotes}</p>
				</div>
				<button
					onClick={toggleExpansion}
					className="mt-4 text-blue-600 hover:underline"
				>
					{isExpanded ? 'Show less' : '... click to read more'}
				</button>
				{isExpanded && (
					<button className="z-10 mt-4 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
						Go to {race.raceName}
					</button>
				)}
			</div>
			<div className="mt-auto border-t border-gray-200 bg-white p-4">
				<p className="text-sm text-gray-600">
					Race Date:{' '}
					{new Date(race.raceDate ?? '').toLocaleDateString('en-US', {
						dateStyle: 'medium',
					})}
				</p>
				<p className="text-sm text-gray-600">Finish Time: {race.finishTime}</p>
			</div>
		</Link>
	)
}
